

























import { Component, Vue, Prop } from "vue-property-decorator";
import { serverBase } from "../apollo";
import IImage from "../types/image";

@Component
export default class ImageCard extends Vue {
  @Prop(Object) image!: IImage;
  @Prop({ default: false }) contain!: boolean;

  imageLink(image: IImage) {
    return `${serverBase}/media/image/${image._id}/thumbnail?password=${localStorage.getItem(
      "password"
    )}`;
  }
}
